import Vue from "vue";
import VueI18n from "vue-i18n";

/*import en from "vuetify/lib/locale/en";
import de from "vuetify/lib/locale/de";*/
import zhHans from "vuetify/lib/locale/zh-Hans";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const locales = [
  /*{
    value: "en",
    text: "English",
    dataUrl: "/data/input-data-sentiment-EN.csv",
    sentiments: ["positive", "negative", "neutral", "mixed"]
  },
  {
    value: "de",
    text: "Deutsch",
    dataUrl: "/data/input-data-sentiment-DE.csv",
    sentiments: ["positiv", "negativ", "neutral", "gemischt"]
  },*/
  {
    value: "zhHans",
    text: "中文",
    dataUrl: "/data/input-data-sentiment-ZH.csv",
    sentiments: ["积极", "消极", "混合", "中性"]
  }
];

const vuetifyLocales = { zhHans };

export { locales, vuetifyLocales };

export default new VueI18n({
  locale: "zhHans",
  fallbackLocale: "zhHans",
  messages: loadLocaleMessages()
});
